<h2 class="fs-title">Foreur</h2>

<dup-acteur-form [acteur]="ouvrage.acteurForeur" isDeclarant="false" ></dup-acteur-form>
<input type="button" name="previous" class="previous action-button-previous" value="Annuler" (click)="gotoAccueil($event)" />
<input type="button" name="next" class="next action-button" value="Sauvegarder" (click)="save()" [disabled]="validateForeur()" />